import api from './api'

/**
 * Auditoria de segurança dos dispositivos (achados AIO-MK-nn).
 * A varredura é somente leitura no equipamento — nada é alterado automaticamente.
 */
export const securityApi = {
  overview: async (tenantId) => {
    const r = await api.get(`/tenants/${tenantId}/security-overview`)
    return r.data
  },
  listByTenant: async (tenantId, { includeResolved = false } = {}) => {
    const r = await api.get(`/tenants/${tenantId}/security-findings`, { params: { includeResolved } })
    return r.data
  },
  listByDevice: async (deviceId, { includeResolved = false } = {}) => {
    const r = await api.get(`/managed-devices/${deviceId}/security-findings`, { params: { includeResolved } })
    return r.data
  },
  scanNow: async (deviceId) => {
    const r = await api.post(`/managed-devices/${deviceId}/security-scan`)
    return r.data
  },
}

export const SEVERITIES = ['critical', 'high', 'medium', 'low']

export const SEVERITY_META = {
  critical: { label: 'Crítico', cls: 'bg-red-100 text-red-800', dot: 'bg-red-600' },
  high: { label: 'Alto', cls: 'bg-red-50 text-red-700', dot: 'bg-red-400' },
  medium: { label: 'Médio', cls: 'bg-amber-50 text-amber-700', dot: 'bg-amber-500' },
  low: { label: 'Baixo', cls: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' },
}

export const severityMeta = (s) => SEVERITY_META[s] || SEVERITY_META.low
